const Kategoriya3112 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                3-sinf 1-chorak<br />
                Mavzu: Gap va uning turlari<br />
                "Oson" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
            </h3>
            <b>1-mashq. Aralash berilgan so'zlarni o'qing va so'roqlar asosida quyidagi jadvalda guruhlang.</b><br />
            <i>Ta'limiy maqsad:</i> O'quvchilarning grammatik kompetensiyalarini rivojlantirish.<br />
            <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
            Bordi, Nozim, uxladi, kitob, samo, dunyo, bola, bodom, gulladi, tashidi, it, kit, uchadi, odam, inson, til, ko'zgu.
            <table border="1">
                <tr>
                    <td>Kim?</td>
                    <td>Nima?</td>
                    <td>Nima qildi?</td>
                </tr>
                <tr>
                    <td>…</td>
                    <td>…</td>
                    <td>…</td>
                </tr>
            </table>
            <p><b>2-mashq. So'zlarni o'qing va xatolarni aniqlab, to'g'risini yozing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning imloviy ko'nikmalarini oshirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
            <table border="1">
                <tr>
                    <td>Imloviy xato so'zlar</td>
                    <td>Xatosiz so'zlar</td>
                </tr>
                <tr>
                    <td>gultojiho'roz</td>
                    <td>gultojixo'roz</td>
                </tr>
                <tr>
                    <td>bemani</td>
                    <td></td>
                </tr>
                <tr>
                    <td>kaltapaxm</td>
                    <td></td>
                </tr>
                <tr>
                    <td>sinoot</td>
                    <td></td>
                </tr>
                <tr>
                    <td>insonyat</td>
                    <td></td>
                </tr>
            </table>
            <p><b>3-mashq. So'z birikmalari tuzing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning sintaktik kompetensiyalarini rivojlantirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 2-3 daqiqa</p>
            <ul>
                <li>obod &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; harorat</li>
                <li>hushyor &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ona</li>
                <li>mehribon &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; echki</li>
                <li>saxovatli &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; bola</li>
                <li>oriq &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; yurt</li>
                <li>yuqori &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; harorat</li>
            </ul>
            <p><b>4-mashq. Nuqtalar o'rniga mos so'zni tanlab yozing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning imloviy savodxonlik ko'nikmalarini oshirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa.</p>
            <p>Ahil oila … (yurtning, jamiyatning, xalqning) ko'rkidir. Sabr qilsang, … (pishloqdan, shakardan, kutishdan, g'o'radan) halvo bitadi. Mahallada … (hasher, oshar, ish, qurilish) boshlandi, katta-kichik, yosh-yalang unda qatnashish uchun kela boshladi. ...(piyoz, beda, ko'kat, sarimsoqpiyoz) – ming xil dardga davo.</p>
            <p><b>5-mashq. Aralash berilgan so'zlardan gaplar tuzing.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning sintaktik ko'nikmalarini rivojlantirish.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa.</p>
            <p>bog'ga, Botir, bordi</p>
            <p>bedapoyada, otboqar, otlarni, haydadi</p>
            <p>uchirtirdi, chavandoz, ko'pkari, Qora bayir, va, ega bo'ldi, sovringa</p>
            <p><b>6-mashq. Berilgan so'zlar va bir mavzuga doir ibora va gaplardan paragraflar yasash. Aralash tarzda berilgan paragraflarni mantiqiy ketma-ketlikda joylashtiring.</b></p>
            <p><i>Ta'limiy maqsad:</i> O'quvchilarning paragraflar mazmuni asosida mantiqiy izchillikda bir butun matn yaratish malakasini aniqlash.</p>
            <p><i>Mashg'ulot davomiyligi:</i> 15-20 daqiqa.</p>
        </div>
    )
}
export default Kategoriya3112;